import { CommonHelper } from "./common-helper";
import { Enums } from "./enums";
import type { HugeIconName } from "@/icons/icons";

export function formatProjectDate(dateString: string): string {
  if (!dateString) return "";
  return CommonHelper.getDateWithTodayYesterdayFormat(dateString);
}

/**
 * Gets the color for a project status
 * @param statusId - Project status ID
 * @returns Color hex string
 */
export function getProjectStatusColor(
  statusId: number | null | undefined,
): string {
  if (!statusId) {
    return "";
  }

  switch (statusId) {
    case Enums.ProjectStatus.Completed: // 3
      return "#4CAF50";
    case Enums.ProjectStatus.OnHold: // 4
      return "#2196F3";
    case Enums.ProjectStatus.InProgress: // 2
      return "#F0BF00";
    case Enums.ProjectStatus.NotStarted: // 1
    case Enums.ProjectStatus.Closed: // 5
    default:
      return "#E2E2E2";
  }
}

/**
 * Gets the display text for a project status
 * @param statusId - Project status ID
 * @returns Status text string
 */
export function getProjectStatusText(
  statusId: number | null | undefined,
): string {
  if (!statusId) {
    return "";
  }

  switch (statusId) {
    case Enums.ProjectStatus.Completed: // 3
      return "Completed";
    case Enums.ProjectStatus.OnHold: // 4
      return "On Hold";
    case Enums.ProjectStatus.InProgress: // 2
      return "In Progress";
    case Enums.ProjectStatus.NotStarted: // 1
      return "Not Started";
    case Enums.ProjectStatus.Closed: // 5
      return "Closed";
    default:
      return "Not Started";
  }
}

export function getProjectTaskStatusText(
  statusId: number | null | undefined,
): string {
  if (!statusId) {
    return "Not Started";
  }

  switch (statusId) {
    case Enums.TaskStatus.Done: // 4
      return "Done";
    case Enums.TaskStatus.OnHold: // 3
      return "On Hold";
    case Enums.TaskStatus.WorkingOnIt: // 2
      return "Working On It";
    case Enums.TaskStatus.NotStarted: // 1
      return "Not Started";
    default:
      return "Not Started";
  }
}

export function getProjectTaskStatusBadgeClass(statusId: number): string {
  switch (statusId) {
    case Enums.TaskStatus.Done:
      return "badge--green";
    case Enums.TaskStatus.OnHold:
      return "tkt-badge--on-hold";
    case Enums.TaskStatus.WorkingOnIt:
      return "tkt-badge--progress";
    default:
      return "tkt-badge--closed";
  }
}

export function getProjectTaskStatusHugeIcon(statusId: number): HugeIconName {
  switch (statusId) {
    case Enums.TaskStatus.Done:
      return "checkmarkCircle02";
    case Enums.TaskStatus.OnHold:
      return "minus01";
    case Enums.TaskStatus.WorkingOnIt:
      return "progress03";
    default:
      return "circleStroke";
  }
}

export function getProjectTaskStatusIconColor(statusId: number): string {
  switch (statusId) {
    case Enums.TaskStatus.Done:
      return "var(--color-decoration-green)";
    case Enums.TaskStatus.OnHold:
      return "var(--color-decoration-light-blue)";
    case Enums.TaskStatus.WorkingOnIt:
      return "var(--color-decoration-yellow-05)";
    default:
      return "var(--color-decoration-gray-05)";
  }
}
